export default {
  getStates: (state) => state.states,
};
